import { InstanceLink } from '~/components/Details/InstanceDetails/MenuInstances';
import { ObjectLiteral } from '~/types/generics';

// Action Types
export enum IProcessTypes {
  GET_PROCESSES_REQUEST = '@processes/GET_PROCESSES_REQUEST',
  GET_PROCESSES_SUCCESS = '@processes/GET_PROCESSES_SUCCESS',
  GET_PROCESSES_FAILURE = '@processes/GET_PROCESSES_FAILURE',

  GET_PROCESS_REQUEST = '@processes/GET_PROCESS_REQUEST',
  GET_PROCESS_SUCCESS = '@processes/GET_PROCESS_SUCCESS',
  GET_PROCESS_FAILURE = '@processes/GET_PROCESS_FAILURE',

  GET_AVAILABLE_AND_FAVORITE_PROCESSES_REQUEST = '@processes/GET_AVAILABLE_AND_FAVORITE_PROCESSES_REQUEST',
  GET_AVAILABLE_AND_FAVORITE_PROCESSES_SUCCESS = '@processes/GET_AVAILABLE_AND_FAVORITE_PROCESSES_SUCCESS',
  GET_AVAILABLE_AND_FAVORITE_PROCESSES_FAILURE = '@processes/GET_AVAILABLE_AND_FAVORITE_PROCESSES_FAILURE',

  CREATE_FAVORITE_PROCESS_REQUEST = '@processes/CREATE_FAVORITE_PROCESS_REQUEST',
  CREATE_FAVORITE_PROCESS_SUCCESS = '@processes/CREATE_FAVORITE_PROCESS_SUCCESS',
  CREATE_FAVORITE_PROCESS_FAILURE = '@processes/CREATE_FAVORITE_PROCESS_FAILURE',

  DELETE_FAVORITE_PROCESS_REQUEST = '@processes/DELETE_FAVORITE_PROCESS_REQUEST',
  DELETE_FAVORITE_PROCESS_SUCCESS = '@processes/DELETE_FAVORITE_PROCESS_SUCCESS',
  DELETE_FAVORITE_PROCESS_FAILURE = '@processes/DELETE_FAVORITE_PROCESS_FAILURE',

  GET_PROCESSES_COUNT_BY_STATUS_REQUEST = '@processes/GET_PROCESSES_COUNT_BY_STATUS_REQUEST',
  GET_PROCESSES_COUNT_BY_STATUS_SUCCESS = '@processes/GET_PROCESSES_COUNT_BY_STATUS_SUCCESS',
  GET_PROCESSES_COUNT_BY_STATUS_FAILURE = '@processes/GET_PROCESSES_COUNT_BY_STATUS_FAILURE',

  GET_PROCESSES_SOLICITATIONS_REQUEST = '@processes/GET_PROCESSES_SOLICITATIONS_REQUEST',
  GET_PROCESSES_SOLICITATIONS_SUCCESS = '@processes/GET_PROCESSES_SOLICITATIONS_SUCCESS',
  GET_PROCESSES_SOLICITATIONS_FAILURE = '@processes/GET_PROCESSES_SOLICITATIONS_FAILURE',

  GET_PROCESSES_SOLICITATIONS_COUNT_REQUEST = '@processes/GET_PROCESSES_SOLICITATIONS_COUNT_REQUEST',
  GET_PROCESSES_SOLICITATIONS_COUNT_SUCCESS = '@processes/GET_PROCESSES_SOLICITATIONS_COUNT_SUCCESS',
  GET_PROCESSES_SOLICITATIONS_COUNT_FAILURE = '@processes/GET_PROCESSES_SOLICITATIONS_COUNT_FAILURE',

  GET_PROCESSES_EXECUTIONS_REQUEST = '@processes/GET_PROCESSES_EXECUTIONS_REQUEST',
  GET_PROCESSES_EXECUTIONS_SUCCESS = '@processes/GET_PROCESSES_EXECUTIONS_SUCCESS',
  GET_PROCESSES_EXECUTIONS_FAILURE = '@processes/GET_PROCESSES_EXECUTIONS_FAILURE',

  GET_PROCESSES_EXECUTIONS_COUNT_REQUEST = '@processes/GET_PROCESSES_EXECUTIONS_COUNT_REQUEST',
  GET_PROCESSES_EXECUTIONS_COUNT_SUCCESS = '@processes/GET_PROCESSES_EXECUTIONS_COUNT_SUCCESS',
  GET_PROCESSES_EXECUTIONS_COUNT_FAILURE = '@processes/GET_PROCESSES_EXECUTIONS_COUNT_FAILURE',

  GET_PROCESS_INSTANCE_REQUEST = '@processes/GET_PROCESS_INSTANCE_REQUEST',
  GET_PROCESS_INSTANCE_SUCCESS = '@processes/GET_PROCESS_INSTANCE_SUCCESS',
  GET_PROCESS_INSTANCE_FAILURE = '@processes/GET_PROCESS_INSTANCE_FAILURE',

  INSTANTIATE_PROCESS_REQUEST = '@processes/INSTANTIATE_PROCESS_REQUEST',
  INSTANTIATE_PROCESS_SUCCESS = '@processes/INSTANTIATE_PROCESS_SUCCESS',
  INSTANTIATE_PROCESS_FAILURE = '@processes/INSTANTIATE_PROCESS_FAILURE',

  GET_PROCESS_XML_REQUEST = '@processes/GET_PROCESS_XML_REQUEST',
  GET_PROCESS_XML_SUCCESS = '@processes/GET_PROCESS_XML_SUCCESS',
  GET_PROCESS_XML_FAILURE = '@processes/GET_PROCESS_XML_FAILURE',

  GET_PROCESS_FORM_REQUEST = '@processes/GET_PROCESS_FORM_REQUEST',
  GET_PROCESS_FORM_SUCCESS = '@processes/GET_PROCESS_FORM_SUCCESS',
  GET_PROCESS_FORM_FAILURE = '@processes/GET_PROCESS_FORM_FAILURE',

  CANCEL_PROCESS_SOLICITATIONS_REQUEST = '@processes/CANCEL_PROCESS_SOLICITATIONS_REQUEST',
  CANCEL_PROCESS_SOLICITATIONS_SUCCESS = '@processes/CANCEL_PROCESS_SOLICITATIONS_SUCCESS',
  CANCEL_PROCESS_SOLICITATIONS_FAILURE = '@processes/CANCEL_PROCESS_SOLICITATIONS_FAILURE',

  CANCEL_PROCESS_EXECUTIONS_REQUEST = '@processes/CANCEL_PROCESS_EXECUTIONS_REQUEST',
  CANCEL_PROCESS_EXECUTIONS_SUCCESS = '@processes/CANCEL_PROCESS_EXECUTIONS_SUCCESS',
  CANCEL_PROCESS_EXECUTIONS_FAILURE = '@processes/CANCEL_PROCESS_EXECUTIONS_FAILURE',

  GET_EXECUTION_LIST_BY_SOLICITATION_REQUEST = '@processes/GET_EXECUTION_LIST_BY_SOLICITATION_REQUEST',
  GET_EXECUTION_LIST_BY_SOLICITATION_SUCCESS = '@processes/GET_EXECUTION_LIST_BY_SOLICITATION_SUCCESS',
  GET_EXECUTION_LIST_BY_SOLICITATION_FAILURE = '@processes/GET_EXECUTION_LIST_BY_SOLICITATION_FAILURE',
}
export interface IGetProcessesRequestAction {
  type: typeof IProcessTypes.GET_PROCESSES_REQUEST;
  payload: {
    personId: number;
    processDefinitionKey: string;
    orgId: string | number;
  };
}
export interface IGetProcessesSuccessAction {
  type: typeof IProcessTypes.GET_PROCESSES_SUCCESS;
  payload: { processes: IProcess[] };
}
export interface IGetProcessesFailureAction {
  type: typeof IProcessTypes.GET_PROCESSES_FAILURE;
}

export interface IGetProcessRequestAction {
  type: typeof IProcessTypes.GET_PROCESS_REQUEST;
  payload: {
    key: string;
    tenantId: string;
  };
}
export interface IGetProcessSuccessAction {
  type: typeof IProcessTypes.GET_PROCESS_SUCCESS;
  payload: { process: IProcess };
}
export interface IGetProcessFailureAction {
  type: typeof IProcessTypes.GET_PROCESS_FAILURE;
}

export interface IGetAvailableAndFavoriteProcessesRequestAction {
  type: typeof IProcessTypes.GET_AVAILABLE_AND_FAVORITE_PROCESSES_REQUEST;
  payload: {
    personId: number;
  };
}
export interface IGetAvailableAndFavoriteProcessesSuccessAction {
  type: typeof IProcessTypes.GET_AVAILABLE_AND_FAVORITE_PROCESSES_SUCCESS;
  payload: { availableProcesses: IProcess[]; favoriteProcesses: IProcess[] };
}
export interface IGetAvailableAndFavoriteProcessesFailureAction {
  type: typeof IProcessTypes.GET_AVAILABLE_AND_FAVORITE_PROCESSES_FAILURE;
}

export interface ICreateFavoriteProcessRequestAction {
  type: typeof IProcessTypes.CREATE_FAVORITE_PROCESS_REQUEST;
  payload: {
    personId: number;
    processDefinitionKey: string;
    orgId: string | number;
  };
}
export interface ICreateFavoriteProcessSuccessAction {
  type: typeof IProcessTypes.CREATE_FAVORITE_PROCESS_SUCCESS;
}
export interface ICreateFavoriteProcessFailureAction {
  type: typeof IProcessTypes.CREATE_FAVORITE_PROCESS_FAILURE;
  payload: { processDefinitionKey: string };
}

export interface IDeleteFavoriteProcessRequestAction {
  type: typeof IProcessTypes.DELETE_FAVORITE_PROCESS_REQUEST;
  payload: {
    personId: number;
    processDefinitionKey: string;
  };
}
export interface IDeleteFavoriteProcessSuccessAction {
  type: typeof IProcessTypes.DELETE_FAVORITE_PROCESS_SUCCESS;
}
export interface IDeleteFavoriteProcessFailureAction {
  type: typeof IProcessTypes.DELETE_FAVORITE_PROCESS_FAILURE;
  payload: { processDefinitionKey: string };
}

export interface IGetProcessesCountByStatusRequestAction {
  type: typeof IProcessTypes.GET_PROCESSES_COUNT_BY_STATUS_REQUEST;
  payload: { params: { page: number; limit: number } };
}
export interface IGetProcessesCountByStatusSuccessAction {
  type: typeof IProcessTypes.GET_PROCESSES_COUNT_BY_STATUS_SUCCESS;
  payload: { processesCountByStatus: any[]; total: number };
}

export interface IGetProcessesCountByStatusFailureAction {
  type: typeof IProcessTypes.GET_PROCESSES_COUNT_BY_STATUS_FAILURE;
}

export interface IInstantiateProcessRequestAction {
  type: typeof IProcessTypes.INSTANTIATE_PROCESS_REQUEST;
  payload: {
    process: IProcess;
    variables: {
      [key: string]: any;
    };
    processFiles: IProcessFile[];
  };
}
export interface IInstantiateProcessSuccessAction {
  type: typeof IProcessTypes.INSTANTIATE_PROCESS_SUCCESS;
}
export interface IInstantiateProcessFailureAction {
  type: typeof IProcessTypes.INSTANTIATE_PROCESS_FAILURE;
}

export interface IGetProcessXMLRequestAction {
  type: typeof IProcessTypes.GET_PROCESS_XML_REQUEST;
  payload: {
    key: string;
    tenant_id: string;
  };
}
export interface IGetProcessXMLSuccessAction {
  type: typeof IProcessTypes.GET_PROCESS_XML_SUCCESS;
  payload: { process: IProcess };
}
export interface IGetProcessXMLFailureAction {
  type: typeof IProcessTypes.GET_PROCESS_XML_FAILURE;
}

export interface IGetProcessesSolicitationsRequestAction {
  type: typeof IProcessTypes.GET_PROCESSES_SOLICITATIONS_REQUEST;
  payload: {
    params: ObjectLiteral;
  };
}
export interface IGetProcessesSolicitationsSuccessAction {
  type: typeof IProcessTypes.GET_PROCESSES_SOLICITATIONS_SUCCESS;
  payload: {
    processesSolicitations: IProcessesInstance[];
    processesType: 'inProgress' | 'completed' | 'deleted';
    total: string;
  };
}
export interface IGetProcessesSolicitationsFailureAction {
  type: typeof IProcessTypes.GET_PROCESSES_SOLICITATIONS_FAILURE;
}

export interface IGetProcessesSolicitationsCountRequestAction {
  type: typeof IProcessTypes.GET_PROCESSES_SOLICITATIONS_COUNT_REQUEST;
  payload: {
    params: {
      limit: number;
    };
  };
}
export interface IGetProcessesSolicitationsCountSuccessAction {
  type: typeof IProcessTypes.GET_PROCESSES_SOLICITATIONS_COUNT_SUCCESS;
  payload: {
    totalInProgress: string;
    totalCompleted: string;
    totalTerminated: string;
    pagecountInProgress: string;
    pagecountCompleted: string;
    pagecountTerminated: string;
  };
}
export interface IGetProcessesSolicitationsCountFailureAction {
  type: typeof IProcessTypes.GET_PROCESSES_SOLICITATIONS_COUNT_FAILURE;
}

export interface IGetProcessesExecutionsRequestAction {
  type: typeof IProcessTypes.GET_PROCESSES_EXECUTIONS_REQUEST;
  payload: {
    params: ObjectLiteral;
  };
}
export interface IGetProcessesExecutionsSuccessAction {
  type: typeof IProcessTypes.GET_PROCESSES_EXECUTIONS_SUCCESS;
  payload: {
    processesExecutions: IProcessesInstance[];
    processesExecutionsHistory: IProcessesHistory[];
    processesType: 'inProgress' | 'completed' | 'deleted';
    total: string;
  };
}
export interface IGetProcessesExecutionsFailureAction {
  type: typeof IProcessTypes.GET_PROCESSES_EXECUTIONS_FAILURE;
}

export interface IGetProcessesExecutionsCountRequestAction {
  type: typeof IProcessTypes.GET_PROCESSES_EXECUTIONS_COUNT_REQUEST;
  payload: {
    params: ObjectLiteral;
  };
}
export interface IGetProcessesExecutionsCountSuccessAction {
  type: typeof IProcessTypes.GET_PROCESSES_EXECUTIONS_COUNT_SUCCESS;
  payload: {
    processesExecutionsInProgressTotal: string;
    processesExecutionsCompletedTotal: string;
    processesExecutionsTerminatedTotal: string;
    processesExecutionsTotal: number;
  };
}
export interface IGetProcessesExecutionsCountFailureAction {
  type: typeof IProcessTypes.GET_PROCESSES_EXECUTIONS_COUNT_FAILURE;
}

export interface IGetProcessInstanceRequestAction {
  type: typeof IProcessTypes.GET_PROCESS_INSTANCE_REQUEST;
  payload: {
    id: string;
    objectType: IProcessInstanceObjectType;
  };
}
export interface IGetProcessInstanceSuccessAction {
  type: typeof IProcessTypes.GET_PROCESS_INSTANCE_SUCCESS;
  payload: {
    processInstance: IProcessesInstance;
    objectType: IProcessInstanceObjectType;
  };
}
export interface IGetProcessInstanceFailureAction {
  type: typeof IProcessTypes.GET_PROCESS_INSTANCE_FAILURE;
  payload: {
    objectType: IProcessInstanceObjectType;
  };
}

export interface IGetProcessFormRequestAction {
  type: typeof IProcessTypes.GET_PROCESS_FORM_REQUEST;
  payload: {
    process: IProcess;
  };
}
export interface IGetProcessFormSuccessAction {
  type: typeof IProcessTypes.GET_PROCESS_FORM_SUCCESS;
  payload: {
    process_id: string;
    form: IProcessXmlFormFieldParsed[];
  };
}
export interface IGetProcessFormFailureAction {
  type: typeof IProcessTypes.GET_PROCESS_FORM_FAILURE;
  payload: {
    process_id: string;
  };
}

export interface ICancelProcessSolicitationsRequestAction {
  type: typeof IProcessTypes.CANCEL_PROCESS_SOLICITATIONS_REQUEST;
  payload: {
    processInstanceId: string;
    processDetails: IProcessDetails;
    data: ObjectLiteral;
  };
}
export interface ICancelProcessSolicitationsSuccessAction {
  type: typeof IProcessTypes.CANCEL_PROCESS_SOLICITATIONS_SUCCESS;
  payload: {
    processInstanceId: string;
  };
}
export interface ICancelProcessSolicitationsFailureAction {
  type: typeof IProcessTypes.CANCEL_PROCESS_SOLICITATIONS_FAILURE;
  payload: unknown;
}

export interface ICancelProcessExecutionsRequestAction {
  type: typeof IProcessTypes.CANCEL_PROCESS_EXECUTIONS_REQUEST;
  payload: {
    processInstanceId: string;
    data: ObjectLiteral;
  };
}
export interface ICancelProcessExecutionsSuccessAction {
  type: typeof IProcessTypes.CANCEL_PROCESS_EXECUTIONS_SUCCESS;
  payload: {
    processInstanceId: string;
  };
}
export interface ICancelProcessExecutionsFailureAction {
  type: typeof IProcessTypes.CANCEL_PROCESS_EXECUTIONS_FAILURE;
  payload: unknown;
}

export interface IGetExecutionListBySolicitationRequestAction {
  type: typeof IProcessTypes.GET_EXECUTION_LIST_BY_SOLICITATION_REQUEST;
  payload: {
    id: string;
  };
}
export interface IGetExecutionListBySolicitationSuccessAction {
  type: typeof IProcessTypes.GET_EXECUTION_LIST_BY_SOLICITATION_SUCCESS;
  payload: {
    executions: Array<InstanceLink>;
  };
}
export interface IGetExecutionListBySolicitationFailureAction {
  type: typeof IProcessTypes.GET_EXECUTION_LIST_BY_SOLICITATION_FAILURE;
}

export type IProcessActionsType =
  | IGetProcessesRequestAction
  | IGetProcessesSuccessAction
  | IGetProcessesFailureAction
  | IGetProcessRequestAction
  | IGetProcessSuccessAction
  | IGetProcessFailureAction
  | IGetAvailableAndFavoriteProcessesRequestAction
  | IGetAvailableAndFavoriteProcessesSuccessAction
  | IGetAvailableAndFavoriteProcessesFailureAction
  | ICreateFavoriteProcessRequestAction
  | ICreateFavoriteProcessSuccessAction
  | ICreateFavoriteProcessFailureAction
  | IDeleteFavoriteProcessRequestAction
  | IDeleteFavoriteProcessSuccessAction
  | IDeleteFavoriteProcessFailureAction
  | IGetProcessesCountByStatusRequestAction
  | IGetProcessesCountByStatusSuccessAction
  | IGetProcessesCountByStatusFailureAction
  | IGetProcessesSolicitationsRequestAction
  | IGetProcessesSolicitationsSuccessAction
  | IGetProcessesSolicitationsFailureAction
  | IGetProcessesSolicitationsCountRequestAction
  | IGetProcessesSolicitationsCountSuccessAction
  | IGetProcessesSolicitationsCountFailureAction
  | IGetProcessesExecutionsRequestAction
  | IGetProcessesExecutionsSuccessAction
  | IGetProcessesExecutionsFailureAction
  | IGetProcessesExecutionsCountRequestAction
  | IGetProcessesExecutionsCountSuccessAction
  | IGetProcessesExecutionsCountFailureAction
  | IGetProcessInstanceRequestAction
  | IGetProcessInstanceSuccessAction
  | IGetProcessInstanceFailureAction
  | IGetProcessesSolicitationsCountRequestAction
  | IGetProcessesSolicitationsCountSuccessAction
  | IGetProcessesSolicitationsCountFailureAction
  | IInstantiateProcessRequestAction
  | IInstantiateProcessSuccessAction
  | IInstantiateProcessFailureAction
  | IGetProcessXMLRequestAction
  | IGetProcessXMLSuccessAction
  | IGetProcessXMLFailureAction
  | IGetProcessFormRequestAction
  | IGetProcessFormSuccessAction
  | IGetProcessFormFailureAction
  | IGetProcessXMLFailureAction
  | ICancelProcessSolicitationsRequestAction
  | ICancelProcessSolicitationsSuccessAction
  | ICancelProcessSolicitationsFailureAction
  | ICancelProcessExecutionsRequestAction
  | ICancelProcessExecutionsSuccessAction
  | ICancelProcessExecutionsFailureAction
  | IGetExecutionListBySolicitationRequestAction
  | IGetExecutionListBySolicitationSuccessAction
  | IGetExecutionListBySolicitationFailureAction;

interface IProcessXmlFormFieldValueParsed {
  props: {
    id: string;
    name: string;
  };
}

interface IProcessXmlFormFieldValidationParsed {
  props: {
    name: string;
    config?: string;
  };
}

export interface IProcessXmlFormFieldPropertyParsed {
  props: {
    id: string;
    value?: string;
  };
}

export interface IProcessXmlFormFieldPropsParsed {
  id: string;
  label: string;
  type: string;
  defaultValue: string;
}

export interface IProcessXmlFormFieldParsed {
  props: IProcessXmlFormFieldPropsParsed;
  value: IProcessXmlFormFieldValueParsed[];
  validation?: {
    constraint:
      | IProcessXmlFormFieldValidationParsed[]
      | IProcessXmlFormFieldValidationParsed;
  };
  properties: {
    property:
      | IProcessXmlFormFieldPropertyParsed[]
      | IProcessXmlFormFieldPropertyParsed;
  };
}

export interface IProcessFile {
  id?: string;
  file_name: string;
  s3_file_name: string;
  process_instance_id: string | null;
  task_id: string | null;
  path: string;
  form_field_id?: string;
}

export interface IProcessCountByStatus {
  name: string;
  completed: number;
  inProgress: number;
  cancelled: number;
}

export interface IProcess {
  id: string;
  name: string;
  key: string;
  version: string;
  versionTag: string;
  tenantId: string;
  suspended: boolean;
  processDefinitionId: string;
  processInstanceId: string;
  startableInTasklist: boolean;
  xml?: any;
  form: IProcessXmlFormFieldParsed[] | null;
  formHTML: string | null;
  formVariables: ObjectLiteral;
}

export interface IAvailableAndFavoriteProcess {
  availableProcesses: IProcess[];
  favoriteProcesses: IProcess[];
}

export interface ICreateFavoriteProcess {
  personId: number;
  processDefinitionKey: string;
  orgId: string | number;
}

export interface IDeleteFavoriteProcess {
  personId: number;
  processDefinitionKey: string;
  orgId: string | number;
}

export type IProcessInstanceObjectType = 'solicitation' | 'execution';

export interface IProcessesInstance {
  id: string;
  startTime: string;
  endTime: string;
  processDefinitionName: string;
  processInstanceId: string;
  nomeSolicitacao: string;
  nomeExecucao: string;
  vertical: string;
  registradoPorId: string;
  registradoPor: string;
  tenantId: string | null;
  state: string | null;
  total: number;
  pageCount: number;
  files: IProcessFile[];
  cancelingReason: string;
  variables: ObjectLiteral;
  versionTag: string;
  superProcessInstanceId?: string;
}

export interface IProcessesHistory {
  id: string;
  startTime: string;
  endTime: string;
  processDefinitionName: string;
  nomeSolicitacao: string;
  nomeExecucao: string;
  vertical: string;
  registradoPorId: string;
  registradoPor: string;
  tenantId: string | null;
  state: string | null;
  files: IProcessFile[];
  cancelingReason: string;
  variables: ObjectLiteral;
}

export interface IPaginateValues {
  page?: number;
  limit?: number;
  dateRange: Date[];
}

export interface IProcessState {
  readonly loading: boolean;
  readonly loadingCount: boolean;
  readonly loadingProcessInstance: boolean;
  readonly loadingSolicitation: boolean;
  readonly loadingExecution: boolean;
  readonly loadingProcessCancelation: boolean;
  readonly loadingProcessesSolicitations: boolean;
  readonly loadingProcessesExecutions: boolean;
  readonly loadingExecutionsBySolicitation: boolean;
  process: IProcess | undefined;
  readonly processes: IProcess[] | undefined;
  readonly availableProcesses: IProcess[] | undefined;
  readonly favoriteProcesses: IProcess[] | undefined;
  readonly processesSolicitations: IProcessesInstance[];
  readonly processesCountByStatus: IProcessCountByStatus[];
  readonly processesSolicitationsTotal: number;
  readonly processesSolicitationsInProgressTotal: number;
  readonly processesSolicitationsCompletedTotal: number;
  readonly processesSolicitationsTerminatedTotal: number;
  readonly processesSolicitationsInProgressPageCount: number;
  readonly processesSolicitationsCompletedPageCount: number;
  readonly processesSolicitationsTerminatedPageCount: number;
  readonly processesExecutions: IProcessesInstance[];
  readonly processesExecutionsHistory: IProcessesHistory[];
  readonly processesExecutionsTotal: number;
  readonly processesExecutionsInProgressTotal: number;
  readonly processesExecutionsCompletedTotal: number;
  readonly processesExecutionsTerminatedTotal: number;
  readonly processInstance: IProcessesInstance | undefined;
  readonly solicitationInstance: IProcessesInstance | undefined;
  readonly executionInstance: IProcessesInstance | undefined;
  readonly processesHistory: IProcessesHistory[];
  readonly executionList: Array<InstanceLink>;
  readonly processInstantiated: boolean;
  readonly processCanceled: boolean;
  readonly processSuspended: boolean;
  readonly hasProcessForm: boolean;
  readonly total: number;
  readonly totalExecutions: number;
  readonly totalProcessesHistory: number;
  readonly pageCount: number;
}

export interface IProcessDetails {
  name: string;
  owner: string;
}
